import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from '../helpers/createStyles'
import { theme } from '../styles/theme'

const Pill = ({ text, style }) => {
  const classes = useStyles()

  return (
    <div className={classes.pill} style={style}>
      <span>{text}</span>
    </div>
  )
}

const useStyles = createUseStyles({
  pill: {
    minHeight: theme.spacing(2),
    opacity: 0.8,
    borderWidth: 0.2,
    borderRadius: 90.32,
    fontFamily: 'Sohne, sans-serif',
    fontWeight: 400,
    fontSize: 10,
    color: '#FFFFFF',
    backgroundColor: '#231F20',
    borderColor: theme.colors.border,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderStyle: 'solid',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    width: 'fit-content',
    '& span': {
      opacity: 0.7
    }
  }
})

Pill.propTypes = {
  text: PropTypes.string.isRequired,
  style: PropTypes.object
}

Pill.defaultProps = {
  style: {}
}

export default Pill
